"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormMatchClub = void 0;
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
var FormMatchClub = function (_a) {
    var video = _a.video, setVideo = _a.setVideo, channel = _a.channel, _b = _a.simple, simple = _b === void 0 ? false : _b;
    var _c = ra_fetch_1.useApi('backend').index('teams', { club_id: channel.id }), teams = _c[0], setTeams = _c[1];
    var _d = react_1.useState(ra_fetch_1.Fetcher.collection()), opponents = _d[0], setOpponents = _d[1];
    var team = teams.data.findBy('id', Number(video.team_id));
    react_1.useEffect(function () {
        if (!teams.loading) {
            ra_fetch_1.Fetcher.api('backend')
                .index('teams', { club_id: channel.id })
                .then(function (response) { return setTeams(response.data); });
        }
    }, [channel.id]);
    react_1.useEffect(function () {
        if (team.competition) {
            ra_fetch_1.Fetcher.api('backend')
                .index('teams', { competition_id: team.competition.id })
                .then(function (response) { return setOpponents(response); });
        }
        else {
            setOpponents(ra_fetch_1.Fetcher.collection());
        }
    }, [team]);
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Forms.Field, null,
            simple && react_1.default.createElement(storybook_1.Forms.Label, null, "Kies een team"),
            react_1.default.createElement(storybook_1.Videos.FormTeamSelect, { teams: teams.data, video: video, setVideo: setVideo, label: 'Kies een team', type: 'club' })),
        react_1.default.createElement(storybook_1.Forms.Field, null,
            simple && react_1.default.createElement(storybook_1.Forms.Label, null, "Kies Thuis- / Uitwedstrijd"),
            react_1.default.createElement(storybook_1.Forms.Select, { name: 'team_id', value: video.match_location, onChange: function (match_location) { return setVideo(__assign(__assign({}, video), { match_location: match_location })); }, className: 'flex-1' },
                react_1.default.createElement("option", { value: '' }, "Selecteer Thuis- / Uitwedstrijd"),
                react_1.default.createElement("option", { value: 'home' }, "Home"),
                react_1.default.createElement("option", { value: 'away' }, "Away"))),
        react_1.default.createElement(storybook_1.Forms.Field, null,
            simple && react_1.default.createElement(storybook_1.Forms.Label, null, "Kies een tegenstander"),
            react_1.default.createElement(storybook_1.Videos.FormOpponentSelect, { teams: opponents.data.filter(function (opponent) { return opponent.id !== Number(video.team_id); }), video: video, setVideo: setVideo, label: !team.id ? 'Kies eerst een team' : 'Kies een tegenstander', type: 'club' })),
        !simple && react_1.default.createElement("div", { className: 'flex justify-center gap-md' },
            react_1.default.createElement(storybook_1.Forms.Field, { className: 'w-16' },
                react_1.default.createElement(storybook_1.Videos.FormTeamScore, { video: video, setVideo: setVideo })),
            react_1.default.createElement(storybook_1.Forms.Field, { className: 'w-16' },
                react_1.default.createElement(storybook_1.Videos.FormOpponentScore, { video: video, setVideo: setVideo }))));
};
exports.FormMatchClub = FormMatchClub;
